import React, { createContext, useContext, ReactNode } from 'react';
import { SocketType } from '../utils/socket';

interface SocketContextType {
  socket: SocketType | null;
}

const SocketContext = createContext<SocketContextType | undefined>(undefined);

interface SocketProviderProps {
  children: ReactNode;
  socket: SocketType | null;
}

export const SocketProvider: React.FC<SocketProviderProps> = ({ children, socket }) => {
  return (
    <SocketContext.Provider value={{ socket }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = (): SocketContextType => {
  const context = useContext(SocketContext);
  if (context === undefined) {
    throw new Error('useSocket debe ser usado dentro de un SocketProvider');
  }
  return context;
};
